module.exports = __webpack_public_path__ + "static/media/Dominican Republic.3cce95ab.png";